import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectTesSwitch,
  tesHandleOpenMachineController,
  tesHandleUnSelectIndividualMachine,
  tesSpecificLocationUnselectMachinesHandler,
} from 'shared/slice/tesSwitchSlice';

import {
  selectMCIsExpanded,
} from 'shared/slice/MCIsExpandedSlice';

import { useMediaQuery } from 'react-responsive';

import styled from 'styled-components';

import MasterControlBySwitch from 'shared/components/commonComponentsMC/MasterControlBySwitch';
import IntegratedSwitchLocations from 'shared/components/commonComponentsMC/IntegratedSwitchLocations';
import { selectUnits } from 'shared/slice/unitsSlice';
import { handleResetAllSelectBySwitch } from 'shared/slice/masterControlBySwitchSelectSlice';
import { handleResetAllSelectByLocation } from 'shared/slice/masterControlSelectByLocationSlice';
import {
  useGetScheduleQueries,
  useGetThermocouplesQueries,
  useSetZoneOpeningsState,
} from 'shared/hooks';
import {
  getTesZones,
} from 'shared/services';
import { useQuery } from 'react-query';
import { handleAccessToken } from 'shared/slice/userSlice';
import { useSetOpenMasterControl } from 'shared/hooks/ess_tgs_tes_hooks/useSetOpenMasterControl';
import { EssTgsTesContext } from 'shared/context/contextOfEssTgsTes';
import { loopMachinesHandler } from 'shared/helpers/ess-tgs-tes-mc';
import { filterZonesWithDevices } from 'shared/helpers/locationsCache';

const TesMain = ({ isMasterControl }) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });



  const { tesSwitch ,flatTesSwitch } = useSelector(selectTesSwitch);
  const MCIsExpanded = useSelector(selectMCIsExpanded);
  const { masterControl } = MCIsExpanded.tes;

  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;

  const dispatch = useDispatch();









  const { messageBoxHandler } = useContext(EssTgsTesContext);










  useGetScheduleQueries(flatTesSwitch, 'TES');
  useGetThermocouplesQueries(flatTesSwitch, 'tes');

  useSetOpenMasterControl('tes', isMobile);







  useSetZoneOpeningsState(
    flatTesSwitch,
    masterControl,
    tesHandleOpenMachineController,
    'tes'
  );



















  const { data: tesZones } = useQuery(['tesZones','structured'], ()=>getTesZones({structured:true}).then(filterZonesWithDevices), {
    enabled: !!handleAccessToken,
    staleTime: Infinity,
  });

  const integratedButtonHandler = (
    id,
    state,
    scope,
    temp,
    data,
    type,
    specificLocation
  ) => {
    loopMachinesHandler(
      id,
      state,
      scope,
      type,
      temp,
      data,
      isF,
      tesZones,
      'TES',
      flatTesSwitch,
      dispatch,
      tesHandleUnSelectIndividualMachine,
      tesSpecificLocationUnselectMachinesHandler,
      handleResetAllSelectBySwitch,
      handleResetAllSelectByLocation,
      messageBoxHandler,
      tesSwitch,
    );


























  };






































































































































































































































































































































































































































































































































































  return (
    <Wrapper>
      {isMasterControl || (
        <Section>
          <MasterControlBySwitch
            swtName='tes'
            buttonHandler={integratedButtonHandler}




          />
        </Section>
      )}

      <Section>
        <IntegratedSwitchLocations
          swtName='tes'
          buttonHandler={integratedButtonHandler}





        />
      </Section>
    </Wrapper>
  );
};

export default TesMain;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Section = styled.section`
  &:first-child {
    margin-bottom: 8px;
  }
`;
